<template>
	<div class="z-box-wrap">
		<ul class="head">
			<li :class="{active:activeIndex==0}" @click="activeIndex = 0">增岗申请{{ `(${add.total})` }}</li>
			<li :class="{active:activeIndex==1}" @click="activeIndex = 1">调岗申请{{ `(${mod.total})` }}</li>
		</ul>
	
		<div class="main">
			<!-- 增岗 -->
			<div class="tab-div" v-show="activeIndex == 0">
				<div class="search-head">
					<span>状态：</span>
					<el-select class="top-choose" v-model="add.status" placeholder="请选择" @change="changeType('add')">
						<el-option v-for="item in apply.statusOption" :key="item.id" :value="item.id" :label="item.label">
						</el-option>
					</el-select>
					<span>申请时间：</span>
					<el-date-picker class="top-choose" v-model="add.date_start" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<small>~</small>
					<el-date-picker class="top-choose" v-model="add.date_end" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<div class="front-btn green shift"  @click="addSearch()">查询</div>
				</div>

				<div class="list">
					<div class="list-head">
						<div>申请时间
							<div class="angle-wrap">
								<i class="el-icon-caret-top" :class="{active:add.sort_str == 'createdAt_asc'}" @click="()=>{add.sort_str='createdAt_asc'; addSearch()}"></i>
								<i class="el-icon-caret-bottom"  :class="{active:add.sort_str == 'createdAt_desc'}" @click="()=>{add.sort_str='createdAt_desc'; addSearch()}"></i>
							</div>
						</div>
						<div>申请BU</div>
						<div>岗位名称</div>
						<div>增岗类型</div>
						<div v-show="add.status !='1'">审核人</div>
						<div v-show="add.status !='1'">审核时间</div>
						<div>状态</div>
						<div>操作</div>
					</div>	
					<z-scrollDiv class="list-detail">
						<div class="item" v-for="item in addList" :key="item.id">
							<div>{{ item.created_at }}</div>
							<div class="overhide" :title="item.bu_name">{{ item.bu_name }}</div>
							<div class="overhide" :title="item.position_name">{{ item.position_name }}</div>
							<div>{{ apply.postType[item.req_type] }}</div>
							<div v-show="add.status !='1'" class="overhide" :title="item.real_name">{{ item.real_name }}</div>
							<div v-show="add.status !='1'">{{ item.updated_at }}</div>
							<div :class="{danger:item.status==1}">{{ apply.statusObj[item.status] }}</div>
							<div @click="showSlider(item,'new')" :class="{'orange-text':item.status == 1}">{{ item.status | applyStatus }}</div>
						</div>
						<z-noData :list="addList"></z-noData>
					</z-scrollDiv>	
				</div>

				<z-pagination class="inside" @getPage="addSearch" :data='add.data'></z-pagination>
			</div>

			<!-- 调岗 -->
			<div class="tab-div" v-show="activeIndex == 1">
				<div class="search-head">
					<span>状态：</span>
					<el-select class="top-choose" v-model="mod.status" placeholder="请选择" @change="changeType('mod')">
						<el-option v-for="item in apply.statusOption" :key="item.id" :value="item.id" :label="item.label">
						</el-option>
					</el-select>
					<span>申请时间：</span>
					<el-date-picker class="top-choose" v-model="mod.date_start" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<small>~</small>
					<el-date-picker class="top-choose" v-model="mod.date_end" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<div class="front-btn green shift"  @click="modSearch()">查询</div>
				</div>

				<div class="list">
					<div class="list-head">
						<div>申请时间
							<div class="angle-wrap">
								<i class="el-icon-caret-top" :class="{active:mod.sort_str == 'createdAt_asc'}" @click="()=>{mod.sort_str='createdAt_asc'; modSearch()}"></i>
								<i class="el-icon-caret-bottom" :class="{active:mod.sort_str == 'createdAt_desc'}" @click="()=>{mod.sort_str='createdAt_desc'; modSearch()}"></i>
							</div>
						</div>
						<div>申请BU</div>
						<div>调岗人员</div>
						<div v-show="mod.status!='1'">审核人</div>
						<div v-show="mod.status!='1'">审核时间</div>
						<div>状态</div>
						<div>操作</div>
					</div>	
					<z-scrollDiv class="list-detail">
						<div class="item" v-for="item in modList" :key="item.id">
							<div>{{ item.created_at }}</div>
							<div class="overhide" :title="item.bu_name">{{ item.bu_name }}</div>
							<div class="ellipsis">{{ item.tran_names || "-" }}</div>
							<div v-show="mod.status!='1'" class="overhide" :title="item.real_name">{{ item.real_name }}</div>
							<div v-show="mod.status!='1'">{{ item.updated_at }}</div>
							<div :class="{danger:item.status==1}">{{ apply.statusObj[item.status] }}</div>
							<div @click="showSlider(item,'trans')" :class="{'orange-text':item.status == 1}">{{ item.status | applyStatus }}</div>
						</div>
						<z-noData :list="modList"></z-noData>
					</z-scrollDiv>	
					
				</div>

				<z-pagination class="inside" @getPage="modSearch" :data='mod.data'></z-pagination>
			</div>
		</div>

		<!-- 滑页 -->
		<sliderPage :title="slider_title" :sliderArg="sliderArg" @close="sliderClear">

			<!-- 增岗申请 -->
			<sliderAdd v-if="activeIndex == 0" :sliderArg="sliderArg" :data="slider_data" :examine="sub"></sliderAdd>
			<!-- 调岗申请 -->
			<sliderMod v-if="activeIndex == 1" :sliderArg="sliderArg" :data="slider_data" :examine="sub"></sliderMod>

			<!-- 分支 -->
			<div slot="pass" class="form-tip">
				<div class="text">是否确认提交处理结果</div>
				<div class="btns">
					<el-button @click="sliderArg.insideFlag = false">取 消</el-button>
					<el-button type="primary" v-show="activeIndex == 0" @click="confirmAdd(slider_data.id)">确定</el-button>
					<el-button type="primary" v-show="activeIndex == 1" @click="confirmMod(slider_data.id)">确定</el-button>
				</div>
			</div>

			<div slot="notpass" class="form-tip">
				<div class="text">是否确认提交处理结果</div>
				<div class="btns">
					<el-button @click="sliderArg.insideFlag = false">取 消</el-button>
					<el-button type="primary" v-show="activeIndex == 0" @click="refuseAdd(slider_data.id)">确定</el-button>
					<el-button type="primary" v-show="activeIndex == 1" @click="refuseMod(slider_data.id)">确定</el-button>
				</div>
			</div>



			
		</sliderPage>

	</div>
</template>

<script>
	import sliderPage from "src/components/slider/sliderPage.vue"
	import sliderAdd from "src/components/slider/sliderAdd.vue"
	import sliderMod from "src/components/slider/sliderMod.vue"

	import { mapState } from "vuex";
	import { changeType } from 'src/control/common.js';  //公共方法


	export default {
		components: {
			sliderPage,
			sliderAdd,
			sliderMod,
		},
		data() {
			return {
				activeIndex: 0,  //tab 序号
				sliderArg:{
					flag:false,
					inside_index:0,
					insideFlag:false,
				},
				slider_data:{},
				sub:{
					result:"",   //审核说明
				},

				// 增岗
				add:{
					status:"1",   //状态
					date_start:"", //起始时间
					date_end:"",  //终止时间
					sort_str:"createdAt_desc", //降序

					total:0,  //待处理总数
					data:{},

					sub_result:"",  // 审核文本
				},
				// 调岗
				mod:{
					status:"1",   //状态
					date_start:"", //起始时间
					date_end:"",  //终止时间
					sort_str:"createdAt_desc", //降序

					total:0,  //待处理总数
					data:{},
				},
			}
		},
		computed:{
			...mapState(["picker_special","apply"]),
			addList(){
				return this.add.data.list;
			},
			modList(){
				return this.mod.data.list;
			},
			// padd_0(){
			// 	return this.addList && this.addList.length>=8?"17px":0;
			// },
			// padd_1(){
			// 	return this.modList && this.modList.length>=8?"17px":0;
			// },
			slider_title(){
				return this.activeIndex == 0?"增岗申请":"调岗申请";
			},
		},

		watch:{
			"sliderArg.flag"(val){
				if(val == false){
					this.slider_data = {};
				}
			}
		},
		
		created(){
			this.firstGet();
		},
		
		methods: {
			changeType,
			// 首次加载
			firstGet(){
				this.addFresh({order_str:"createdAt_desc"},function(data){
					this.add.total = data.total;
				});
				this.modFresh({order_str:"createdAt_desc"},function(data){
					this.mod.total = data.total;
				});
			},

			// **增岗申请相关
			addFresh(obj={},func){
				let url = "api/admin/new_position_req_log";
				let config = {params:obj};

				this.$http.get(url,config).then(res=>{
					if(res.status == 200){
						this.add.data = res.res_data;
						func && func.call(this,res.res_data);
					}
				});
			},
			addSearch(page){
				let obj = {
					page:page,
					status:this.add.status,
					start_date:this.add.date_start,
					end_date:this.add.date_end,
					order_str:this.add.sort_str,
				};
				this.addFresh(obj);
			},
			confirmAdd(id){   //通过审核
				let url = `api/admin/new_position_req_log/${id}/pass`;
				this.$http.put(url,{
					result:this.sub.result
				}).then(res=>{
					if(res.status == 200){
						this.successTip("增岗申请已通过");
						this.addFresh({order_str:"createdAt_desc"},function(data){
							this.add.total = data.total;
						});
	
						this.sliderArg.flag = false;
						this.sliderArg.insideFlag = false;
						this.sliderClear();
					}
				}).catch(error=>{
					this.errorTip("操作失败");
				});
			},
			refuseAdd(id){    //驳回审核
				let url = `api/admin/new_position_req_log/${id}/reject`;
				this.$http.put(url,{
					result:this.sub.result
				}).then(res=>{
					if(res.status == 200){

						this.successTip("增岗申请已驳回");
	
						this.addFresh({order_str:"createdAt_desc"},function(data){
							this.add.total = data.total;
						});
	
						this.sliderArg.flag = false;
						this.sliderArg.insideFlag = false;
						this.sliderClear();
					}
				}).catch(error=>{
					this.errorTip("操作失败");
				});
			},

			// ***调岗申请相关**
			modFresh(obj={},func){
				let url = "api/admin/transfer_position_req_log";
				let config = {params:obj};

				this.$http.get(url,config).then(res=>{
					if(res.status == 200){
						this.mod.data = res.res_data;
						func && func.call(this,res.res_data);
					}
				}).catch(error=>{

				});
			},
			modSearch(page){
				let obj = {
					page:page,
					status:this.mod.status,
					start_date:this.mod.date_start,
					end_date:this.mod.date_end,
					order_str:this.mod.sort_str,
				};
				this.modFresh(obj);
			},
			confirmMod(id){  //通过调岗审核
				let url = `api/admin/transfer_position_req_log/${id}/pass`;
				this.$http.put(url,{
					result:this.sub.result
				}).then(res=>{
					if(res.status == 200){
						this.successTip("调岗申请已通过");
	
						this.modFresh({order_str:"createdAt_desc"},function(data){
							this.mod.total = data.total;
						});
	
						this.sliderArg.flag = false;
						this.sliderArg.insideFlag = false;
						this.sliderClear();
					}
				}).catch(error=>{
					this.errorTip("操作失败");
				});
			},
			refuseMod(id){
				let url = `api/admin/transfer_position_req_log/${id}/reject`;
				this.$http.put(url,{
					result:this.sub.result
				}).then(res=>{
					if(res.status == 200){
						this.successTip("调岗申请已驳回");
	
						this.modFresh({order_str:"createdAt_desc"},function(data){
							this.mod.total = data.total;
						});
	
						this.sliderArg.flag = false;
						this.sliderArg.insideFlag = false;
						this.sliderClear();
					}
				}).catch(error=>{
					this.errorTip("操作失败");
				});
			},

			// ****滑页相关***
			showSlider(item,str){
				if(str == "new"){
					this.$http.get(`api/admin/new_position_req_log/${item.id}`).then(res=>{
						if(res.status == 200){
							this.slider_data = res.res_data;
							this.sliderArg.flag = true;
						}
					});
				}else if (str == "trans"){
					this.$http.get(`api/admin/transfer_position_req_log/${item.id}`).then(res=>{
						if(res.status == 200){
							this.slider_data = res.res_data;
							this.sliderArg.flag = true;
						}
					});
				}
				
			},
			sliderClear(){  //滑页关闭回调
				this.sub.result = "";
			},

		}
	}
</script>

<style lang="less" scoped>
	// @import "~src/assets/less/var.less";
	@import "~src/assets/less/application.less";
	.list-head >div,.list-detail .item>div{
			&:nth-of-type(1){
				width: 15%;
			}
			&:nth-of-type(2){
				width: 12%;
			}
			&:nth-of-type(3){
				width: 16%;
			}
			&:nth-of-type(4){
				width: 10%;
			}
			&:nth-of-type(5){
				width: 15%;
			}
			&:nth-of-type(6){
				width: 10%;
			}
			&:nth-of-type(7){
				width: 10%;
			}
		}

	.tab-div:first-of-type{
		.list-head >div,.list-detail .item>div{
			&:nth-of-type(1){
				width: 15%;
			}
			&:nth-of-type(2){
				width: 12%;
			}
			&:nth-of-type(3){
				width: 12%;
			}
			&:nth-of-type(4){
				width: 10%;
			}
			&:nth-of-type(5){
				width: 10%;
			}
			&:nth-of-type(6){
				width: 15%;
			}
			&:nth-of-type(7){
				width: 10%;
			}
			&:nth-of-type(8){
				width: 10%;
			}
		}
	}

	.list-detail .item>div{
		&:last-of-type{
			color: @focus-c;
			cursor:pointer;
		}
	}
</style>





// WEBPACK FOOTER //
// page-personnel-examine.vue?4596217f